<template>
  <div
    v-if="!isNavAlertOpen"
    role="alert"
    class="relative flex w-full px-4 py-4 mt-auto text-base text-white bg-main-900 dark:bg-sub-900 dark:text-gray-900 rounded-lg font-regular transition-colors duration-300"
  >
    <!-- Alert Content -->
    <div class="mr-12">
      <!-- Icon -->
      <svg
        fill="none"
        stroke="currentColor"
        class="w-12 h-12 mb-4"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 64 64"
        enable-background="new 0 0 64 64"
        xml:space="preserve"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            id="Diamond"
            d="M63.6870499,18.5730648L48.7831497,4.278266c-0.1855011-0.1758003-0.4316025-0.4813001-0.6870003-0.4813001 H15.9037514c-0.2553005,0-0.5014,0.3054998-0.6870003,0.4813001l-14.9038,14.1908998 c-0.374,0.3535004-0.4184,0.9855995-0.1025,1.3917999c0.21,0.2703991,30.8237991,39.7256012,31.0517006,39.9812012 c0.1022987,0.1149979,0.2402992,0.2215996,0.3428001,0.266098c0.2763996,0.1206017,0.5077,0.1296997,0.7900982,0.0065002 c0.1025009-0.0444984,0.2404022-0.1348991,0.3428001-0.2499008c0.0151024-0.0168991,0.0377007-0.0224991,0.0517006-0.0404968 L63.789547,19.9121666C64.1054459,19.5058651,64.0610504,18.9265652,63.6870499,18.5730648z M15.6273508,6.4344659 l4.9945002,11.3625011H3.6061509L15.6273508,6.4344659z M24.0795517,17.7969666l7.9203987-11.2617006l7.9204979,11.2617006 H24.0795517z M40.7191467,19.7969666l-8.7191963,34.8769989l-8.719099-34.8769989H40.7191467z M33.9257507,5.7969656h12.5423012 l-4.8240013,10.9746008L33.9257507,5.7969656z M22.3559513,16.7715664L17.53195,5.7969656h12.5423012L22.3559513,16.7715664z M21.2191505,19.7969666l8.6596012,34.638401L2.975451,19.7969666H21.2191505z M42.7808495,19.7969666h18.2436981 l-26.9032974,34.638401L42.7808495,19.7969666z M43.3781471,17.7969666l4.9944992-11.3625011l12.0212021,11.3625011H43.3781471z"
          ></path>
        </g>
      </svg>

      <!-- Heading -->
      <h6
        class="block mb-1 text-base antialiased font-semibold leading-relaxed tracking-normal text-inherit"
      >
        Upgrade to PRO
      </h6>

      <!-- Description -->
      <p
        class="block text-sm antialiased font-normal leading-normal text-inherit opacity-80"
      >
        Unlock exclusive sales features and premium marketing tools
      </p>

      <!-- Buttons -->
      <div class="flex gap-3 mt-4">
        <a
          @click="toggleNavAlert"
          href="#"
          class="block text-sm antialiased font-medium leading-normal text-inherit opacity-80 hover:opacity-100 transition-opacity duration-200"
        >
          Dismiss
        </a>
        <RouterLink
          to="/service-plans"
          @click="toggleNavAlert"
          class="block text-sm antialiased font-medium leading-normal text-inherit hover:opacity-80 transition-opacity duration-200"
        >
          Upgrade Now
        </RouterLink>
      </div>
    </div>

    <!-- Close Button -->
    <button
      @click="toggleNavAlert"
      class="!absolute top-3 right-3 h-8 max-h-[32px] w-8 max-w-[32px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-white transition-all hover:bg-white/10 active:bg-white/30 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
      type="button"
    >
      <span
        class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="w-6 h-6"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NavAlertComponent",
  computed: {
    ...mapGetters(["subscription"]),
    selectedStore() {
      return this.$store.getters.selectedStore;
    },
    isNavAlertOpen() {
      const subscriptionData =
        this.subscription?.find((sub) => sub.storeId === this.selectedStore.id)
          ?.subscription || null;
      return subscriptionData ? subscriptionData.status === "active" : false;
    },
  },
  methods: {
    toggleNavAlert() {
      this.isNavAlertOpen = !this.isNavAlertOpen; // Toggle visibility
    },
  },
};
</script>
